module.exports = __webpack_public_path__ + "img/setUpCards_7.2855b3ab.jpg";